import { Fragment, forwardRef } from "react"

// eslint-disable-next-line react/display-name
const Input = forwardRef(({ error, value, onChange, ...rest }, ref) => {
  function onChangeData(e) {
    const value = e.target.value
    const filteredValue = value.replace(/[^\d]/g, "")

    onChange(filteredValue)
  }

  return (
    <Fragment>
      <div className="relative">
        <input
          ref={ref}
          onChange={onChangeData}
          autoComplete="new-password"
          className="border-b text-dark-300 border-gray-500 outline-none text-lg py-1 w-full bg-transparent"
          {...rest}
          value={value}
          type="tel"
          maxLength={12}
        />
      </div>
      <div className="h-8">{error && <span className="text-red-500 text-sm">{error}</span>}</div>
    </Fragment>
  )
})
export default Input
